import {TIMEZONE_ACTIONS} from "./types";
import {addError} from "./errorActions";
import {GET} from "ith-fetch";
import {addProcessing, removeProcessing} from "./processingActions";
import {PROC_TIMEZONES} from "./index";

export const loadTimezones = (onSuccess) =>
	async (dispatch, getState) => {
		if (!getState().timezones.length) {
			try {
				dispatch(addProcessing(PROC_TIMEZONES));
				const list = await GET('/timezones');
				dispatch({type: TIMEZONE_ACTIONS.LOAD, list});
				onSuccess && onSuccess(list);
			} catch (e) {
				dispatch(addError(e.message));
			} finally {
				dispatch(removeProcessing(PROC_TIMEZONES));
			}
		}
	};


// WEBPACK FOOTER //
// ./src/actions/timezoneActions.js